import { render, staticRenderFns } from "./ClientListSearchComponent.vue?vue&type=template&id=361206d5&"
import script from "./ClientListSearchComponent.vue?vue&type=script&lang=js&"
export * from "./ClientListSearchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports